import { getLanguage } from '../language.utils';
import APP_CONFIG from '../../app.config';

const mod = angular.module('app.common.resources.reservation', [])

.factory('ReservationResource', function ($http) {
  // This does not extend AbstractResource as it would provide methods that should not be used in this application anymore.
  class ReservationResource {
    constructor() {
      this.url = `${APP_CONFIG.be}/reservations/`;

      // Headers to send to backend with every request
      this._headers = { 'Accept-Language': getLanguage() };
    }

    /**
     * Cancels all active temporary reservations for session.
     *
     * @returns {Promise}
     */
    cancelTemporaries() {
      return $http.delete(this.url + 'temporary/', {headers: this._headers});
    }
  }

  return new ReservationResource();
});

export default mod.name;



// WEBPACK FOOTER //
// ./src/app/common/resources/reservation.resource.js